/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tenant-integration-endpoint-attribute.reducer';

export const TenantIntegrationEndpointAttributeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const tenantIntegrationEndpointAttributeEntity = useAppSelector(state => state.tenantIntegrationEndpointAttribute.entity);
  const loading = useAppSelector(state => state.tenantIntegrationEndpointAttribute.loading);
  const updating = useAppSelector(state => state.tenantIntegrationEndpointAttribute.updating);
  const updateSuccess = useAppSelector(state => state.tenantIntegrationEndpointAttribute.updateSuccess);

  const handleClose = () => {
    navigate(`/tenant-integration-endpoint-attribute${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantIntegrationEndpointAttributeEntity,
      ...values,
      valueType: clinicalDictionaries.find(it => it.id.toString() === values.valueType?.toString()),
      valueRange: clinicalDictionaries.find(it => it.id.toString() === values.valueRange?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tenantIntegrationEndpointAttributeEntity,
          valueType: tenantIntegrationEndpointAttributeEntity?.valueType?.id,
          valueRange: tenantIntegrationEndpointAttributeEntity?.valueRange?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.tenantIntegrationEndpointAttribute.home.createOrEditLabel"
            data-cy="TenantIntegrationEndpointAttributeCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.home.createOrEditLabel">
              Create or edit a TenantIntegrationEndpointAttribute
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-integration-endpoint-attribute-id"
                  label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.value')}
                id="tenant-integration-endpoint-attribute-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <UncontrolledTooltip target="valueLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.value" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.active')}
                id="tenant-integration-endpoint-attribute-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.cursor')}
                id="tenant-integration-endpoint-attribute-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.lastUpdated')}
                id="tenant-integration-endpoint-attribute-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.microSec')}
                id="tenant-integration-endpoint-attribute-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.timestampEntry')}
                id="tenant-integration-endpoint-attribute-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tenant-integration-endpoint-attribute-valueType"
                name="valueType"
                data-cy="valueType"
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.valueType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tenant-integration-endpoint-attribute-valueRange"
                name="valueRange"
                data-cy="valueRange"
                label={translate('tinyMedicRestApp.tenantIntegrationEndpointAttribute.valueRange')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tenant-integration-endpoint-attribute"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantIntegrationEndpointAttributeUpdate;
